<template>
  <div class="my-header width1200">
    <div class="left">
      <img src="../image/er.png" alt="" />
      <p>2021年掌上淄师新媒体纳新</p>
    </div>
    <div class="right">2021.03.03 13:12</div>
  </div>
</template>

<script>
export default {
  name: "my-header",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.my-header {
  height: 134px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;
    img {
      width: 76px;
      height: 40px;
      margin-right: 24px;
    }
    p {
      font-size: 40px;
      color: #2a2a2a;
      letter-spacing: 0;
      font-weight: 600;
      margin: 0px;
    }
  }
  .right {
    font-size: 24px;
    color: #2a2a2a;
    letter-spacing: 0;
    font-weight: 700;
  }
}
</style>
